import React, { Component, createContext } from 'react'
import { withRouter } from 'next/router'
import withLanguageContext from '../consumerHOC/LanguageConsumer'

import { getData } from 'helpers'
import withUIContext from 'context/consumerHOC/UIConsumer'

const DataContext = createContext(null)
export const DataConsumer = DataContext.Consumer

class DataProvider extends Component {
    state = { ...this.props.newData, prevRoute: null }

    methods = {
        updateState: this.updateState.bind(this),
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const lang = this.props.router.locale || this.props.selectedLang

        if (prevProps.router.asPath !== this.props.router.asPath || prevProps.router.locale !== this.props.router.locale) {
            this.props.toggleLoading(true)
            getData({ lang, state: this.state, router: this.props.router }).then((res) => {
                this.setState({ ...res, loading: false, prevRoute: prevProps.router }, () => {
                    this.props.toggleLoading(false)
                })
            })
        }
    }

    updateState(state) {
        this.setState(state)
    }

    render() {
        return <DataContext.Provider value={{ ...this.state, ...this.methods }}>{this.props.children}</DataContext.Provider>
    }
}

export default withUIContext(withRouter(withLanguageContext(DataProvider, ['selectedLang'])), ['toggleLoading'])
